<template>
  <div>
    <div v-if="f_field.headline" class="mt-5 mb-3">
      <v-flex
        style="background-color: #eaeaea; color: #444444"
        class="px-3 py-2 elevation-0 xs12"
      >
        <h3 class="font-weight-bold body-2 text-uppercase xs12 flex">
          {{ f_field.title }}
          <v-menu offset-y class="right mb-1" v-if="!f_field.no_dynamic">
            <v-btn
              slot="activator"
              color="grey lighten-3"
              small
              icon
              class="mt-0 mb-0"
            >
              <v-icon small>add</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                v-for="item in dynamic_field_list"
                :key="item.name"
                @click="add_field(item.name)"
              >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </h3>
        <!-- <v-divider color='black'></v-divider> -->
      </v-flex>
    </div>

    <div v-else-if="f_field.subheadline" class="mt-2 mb-1">
      <v-flex style="" class="px-3 pb-0 xs12">
        <h3 class="xs12 flex">
          {{ f_field.title }}
          <!-- <v-menu offset-y class="right mb-1" v-if="!f_field.no_dynamic">
            <v-btn slot="activator" color="grey lighten-2" small icon class="mt-0 mb-0">
              <v-icon small color="grey lighten-5" >add</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in dynamic_field_list" :key="item.name" @click="add_field(item)">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu> -->
        </h3>
        <!-- <v-divider color='black'></v-divider> -->
      </v-flex>
    </div>

    <div v-if="f_field.component" class="mt-2 mb-2 mx-0">
      <!-- <v-flex style="background-color:#fafafa;" class="px-3 py-2 elevation-1 xs12">
        <h3 class="subtitle xs12 flex">{{f_field.title}}  ({{count}})
            <v-btn @click="showUpload=!showUpload" color="grey lighten-5" small icon class="right mt-0 mb-0">
              <v-icon v-if="!showUpload" small>expand_more</v-icon>
              <v-icon v-if="showUpload" small dark>expand_less</v-icon>
            </v-btn>
        </h3> -->
      <component
        :is="f_field.component"
        :uploadCategory="f_field.title"
        :artwork="f_artwork"
        :name="f_field.name"
        :field="f_field"
        :film="film"
      ></component>
      <!-- </v-flex> -->
    </div>

    <div v-else>
      <v-flex v-if="field_type == 'text-short'" px-3>
        <v-flex>
          <label>{{ label }}</label>

          <!-- v-model="f_field.model_string" -->
          <!-- :value="f_field.value_string" -->
          <v-text-field
            class=""
            :value="`${f_field.name}`"
            :hint="hint"
            v-model="parent[f_field.name]"
            persistent-hint
            :suffix="f_field.suffix"
            @input.native="$emit('input', $event.target.value)"
            @keyup="
              f_field.name == 'acquisition_number'
                ? check_an($event.target.value)
                : ''
            "
          ></v-text-field>
          <!-- :readonly="!isEditing"
            :append-outer-icon="(f_field.no_edit ? '' : (isEditing ? 'save' : 'edit'))"
            @click:append-outer="saveOrEdit" -->
          <div v-if="an_exists">This accession number already exists!</div>
          <!-- <div v-if="saved" class="ml-3">Value was saved!</div>
          <div v-if="cannotSave" class="ml-3">Value already exists! Cannot save!</div> -->
          <!-- <v-btn v-if="f_field.dynamic" class="ml-3">
            <v-icon>remove</v-icon>
          </v-btn> -->
        </v-flex>
      </v-flex>

      <v-flex v-if="field_type == 'currency'" px-3 xs12 sm6 md4 d-flex>
        <v-flex xs12 sm6>
          <label>{{ label }}</label>
          <v-text-field
            class=""
            :readonly="!isEditing"
            :name="f_field.name"
            :ref="f_field.name"
            :value="`${f_artwork[f_field.name]}`"
            :hint="`${f_field.title}`"
            persistent-hint
            :suffix="f_field.suffix"
            @input.native="$emit('input', $event.target.value)"
            @keyup="check_an($event.target.value)"
            :append-outer-icon="
              f_field.no_edit ? '' : isEditing ? 'save' : 'edit'
            "
            @click:append-outer="saveOrEdit"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm6>
          <v-select
            name="f_field.name+'_currency'"
            :items="['EUR', 'USD', 'GBP', 'AUD', 'CHF', 'YEN', 'SIT']"
            label=""
            :append-outer-icon="isEditing ? 'save' : 'edit'"
            :ref="f_field.name"
            :value="f_artwork[`${f_field.name}_currency`]"
            hint="Currency"
            persistent-hint
            @click:append-outer="saveOrEdit"
            class="ml-0"
          ></v-select>
          <div v-if="an_exists">This accession number already exists!</div>
          <div v-if="saved" class="ml-3">Value was saved!</div>
          <div v-if="cannotSave" class="ml-3">
            Value already exists! Cannot save!
          </div>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'text-long'" class="my-0 py-0 px-3">
        <v-textarea
          class="my-0"
          auto-grow
          :readonly="!isEditing"
          :name="f_field.name"
          :ref="f_field.name"
          rows="1"
          :value="`${f_artwork[f_field.name]}`"
          :hint="`${f_field.title} - ${f_field.hint ? f_field.hint : ''}`"
          persistent-hint
          :append-outer-icon="
            f_field.no_edit ? '' : isEditing ? 'save' : 'edit'
          "
          @click:append-outer="saveOrEdit"
          @input.native="$emit('input', $event.target.value)"
        ></v-textarea>
        <div v-if="an_exists">This accession number already exists!</div>
        <div v-if="saved" class="ml-3">Value was saved!</div>
        <div v-if="cannotSave" class="ml-3">
          Value already exists! Cannot save!
        </div>
        <!-- :label="f_field.title" -->
      </v-flex>

      <v-flex
        xs12
        md12
        v-else-if="this.field_type == 'date'"
        :class="`${f_field.class} mt-3 py-0 px-3`"
      >
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="32"
          :nudge-top="18"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="date"
            :label="f_field.title"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
        </v-menu>
        <!-- <v-flex xs4>
            <v-menu
              v-model="menu2" :return-value.sync="f_field.name" ref="menu2"
              :close-on-content-click="true" :nudge-right="40" lazy landscape transition="scale-transition" offset-y full-width min-width="290px"
            >
              <v-text-field
                v-model="f_field.name"
                slot="activator" label="f_field.name" prepend-icon="event" readonly
              ></v-text-field>
              <v-date-picker persistent
                v-model="f_field.name" @input="$refs.menu2.save(f_field.name)">
              </v-date-picker>

            </v-menu>             -->
        <!-- <v-text-field solo
              v-model="model"
              type="number"
              mask="####"
              max="2019"
              min="1900"
              :name="f_field.name"
              :ref="f_field.name"
              :value="`${f_artwork[f_field.name]}`"
              label="Year"
              placeholder="Year"
              hint="Year"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field> -->
        <!-- </v-flex> -->
        <!-- <v-flex xs4>
            <v-text-field solo
              type="number"
              mask="##" 
              max="12"
              :name="f_field.name"
              :ref="f_field.name"
              :value="`${f_artwork[f_field.name]}`"
              label="Month"
              placeholder="Month"
              hint="Month"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field solo
              type="number"
              mask="##" 
              max="31"
              :name="name"
              :value="`${f_artwork[f_field.name]}`"
              label="Day"
              placeholder="Day"
              hint="Day"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-0 py-0">
          <v-flex xs12 class="my-0 py-0">
            <label class="my-0 py-0 pl-2">{{f_field.title}} </label>
            {{artwork[f_field.name]}}
          </v-flex> -->
      </v-flex>

      <v-flex v-else-if="this.field_type == 'bool'" px-3>
        <v-switch
          :value="`${f_artwork[f_field.name]}`"
          :label="`${f_field.title}`"
          color="black"
        ></v-switch>
        <!-- v-model="`${f_field.name}`"  -->
      </v-flex>

      <v-flex v-else-if="this.field_type == 'radio'" px-3>
        <v-radio-group
          v-model="parent[f_field.name]"
          :label="`${f_field.title}`"
          :column="f_field.column ? f_field.column : false"
        >
          <v-radio
            v-for="s in f_field.selection"
            :label="s.name ? s.name : s"
            :value="s.id ? s.id : s"
            :key="s.id ? s.id : s"
            class="ml-3"
          ></v-radio>
        </v-radio-group>

        <v-flex
          class="xs12 elevation-3 py-3 px-3"
          v-if="f_field.name == 'sound' && this.value_new == '1'"
        >
          <v-flex c>
            <v-text-field
              v-model="film.audio_codec"
              label="Audio Codec"
              hint="MP3, AAC, AC3 etc."
            ></v-text-field>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-select
              :items="['32 kHz', '44,1 kHz', '48 kHz', '96 kHz', '192 kHz']"
              label="Audio Resolution"
              class="ml-0"
            ></v-select>
            <!-- <v-radio-group v-model="film.audio_resolution" label="Audio Resolution" row> -->
            <!-- <v-radio v-for="s in ['32 kHz','44,1 kHz','48 kHz','96 kHz','192 kHz']" :label="s" :value="s" :key="s" class="ml-3"></v-radio> -->
            <!-- </v-radio-group> -->
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-radio-group v-model="film.audio_bit" label="Audio Bit" column>
              <v-radio
                v-for="s in ['16 Bit', '20 Bit', '24 Bit']"
                :label="s"
                :value="s"
                :key="s"
                class="ml-3"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-select
              :items="channels"
              item-value="id"
              item-text="name"
              label="Channels"
              class="ml-0"
            ></v-select>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-select
              :items="[
                'light optical tone',
                'magnetic',
                'digital',
                'unknown',
                'other',
              ]"
              label="Audio Specs"
              class="ml-0"
            ></v-select>
            <!-- <v-radio-group v-model="film.audio_specs" label="Audio Specs" row>
              <v-radio v-for="s in ['light optical tone','magnetic','digital','unknown','other']" :label="s" :value="s" :key="s" class="ml-3"></v-radio>
            </v-radio-group> -->
          </v-flex>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'checkbox'" px-3>
        <v-flex>
          <h4 class="sub-headline mt-3 ml-3">{{ f_field.title }}</h4>
          <v-checkbox
            v-for="s in f_field.selection"
            hide-details
            :label="s.name ? s.name : s"
            :key="s.id ? s.id : s"
            class="left mr-3 ml-3"
            :refs="f_field.name"
            >{{ s.name ? s.name : s }}</v-checkbox
          >
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'toggle'" px-3 mb-2>
        <h4 class="body-2 mt-3 ml-1">{{ f_field.title }}</h4>
        <v-flex xs12 sm6 class="py-2">
          <v-btn-toggle v-model="toggle" @change="save">
            <v-btn
              small
              flat
              v-for="s in f_field.selection"
              :key="s.id ? s.value : s"
              class="px-2"
              :value="s.value"
            >
              <!-- <v-icon small>format_align_left</v-icon> -->
              <span> {{ s.name }} </span>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-flex>

      <v-layout v-else-if="f_field.etype === 'select'" px-3 mt-3 row wrap>
        <v-flex>
          <!-- :readonly="!isEditing" -->
          <!-- :value="value2" -->
          <v-select
            v-if="!f_field.just_text"
            v-model="select_value"
            :items="selection_items"
            :label="`${f_field.title}`"
            item-text="name"
            item-value="id"
            :name="f_field.name"
            :ref="f_field.related_field"
            :append-outer-icon="f_field.addNew ? 'add' : ''"
            :preppend-icon="f_field.preicon"
            @click:append-outer="showAddForm"
          >
          </v-select>
          <div v-else>
            {{
              f_artwork[f_field.name]
                ? f_artwork[f_field.name].name
                : 'NOT FOUND'
            }}
          </div>

          <v-flex
            v-if="
              f_field.name == 'classification_new_id' &&
              this.select_value == 'film'
            "
          >
            <v-radio-group
              v-model="film.film_type"
              label="Select Film Type"
              row
            >
              <v-radio
                v-for="s in ['tape', 'film', 'digital born']"
                :label="s"
                :value="s"
                :key="s"
                class="ml-3"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex
            v-if="
              f_field.name == 'classification_new_id' &&
              this.select_value == 'inst'
            "
            class="xs12 mx-3"
          >
            <v-flex class="xs12 mx-3">
              <v-flex class="subheadline mt-4">Includes</v-flex>
              <v-checkbox
                v-for="s in [
                  'Objects',
                  'Sound',
                  'FilmVideoAV',
                  'Slide',
                  'Computer Program / Software / File',
                  'Performance',
                  'Light',
                  'Other',
                ]"
                v-model="instalation_includes"
                :key="s"
                :label="s"
                :value="s"
                hide-details
                xs12
                md6
                lg4
              ></v-checkbox>
            </v-flex>

            <v-flex
              v-if="this.instalation_includes.indexOf('FilmVideoAV') >= 0"
              class="xs12 mx-3"
            >
              <v-radio-group
                v-model="film.film_type"
                label="Select Film Type"
                row
              >
                <v-radio
                  v-for="s in ['tape', 'film', 'digital born']"
                  :label="s"
                  :value="s"
                  :key="s"
                  class="ml-3"
                ></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex
              v-if="this.instalation_includes.indexOf('Other') >= 0"
              class="xs12 mx-3"
            >
              <v-text-field
                v-model="film.film_type"
                class="ml-3"
                name="including_other"
                label="Other"
                row
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-artist v-if="f_field.table=='artists'" itemToAdd="f_field"></add-artist>
      </v-flex> -->
      </v-layout>

      <v-flex v-else-if="f_field.etype === 'autocomplete'" mt-3 px-3>
        <v-autocomplete
          solo
          v-model="value_new"
          :items="this.selection_items"
          :label="`${f_field.title}`"
          item-text="name"
          item-value="id"
          :chips="f_field.chips"
          :multiple="f_field.multiple"
          :append-outer-icon="f_field.addNew ? 'add' : 'remove'"
          @click:append-outer="showAddForm"
        >
          <!-- <v-icon
            @click="addArtistForm = true"
          >plus</v-icon> -->
        </v-autocomplete>
        <!-- <v-btn slot="activator" @click="addArtistForm = true" color="grey lighten-2" small icon>
          <v-icon small>add</v-icon>
        </v-btn> -->
        <!-- <v-flex v-if="f_field.name=='classification_new_id' && this.artwork.classification_new_id=='film'">
          Show fvs sub-options here
        </v-flex> -->
      </v-flex>
      <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-artist
          v-if="f_field.table == 'artists'"
          itemToAdd="f_field"
        ></add-artist>
      </v-flex>
      <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-location
          v-if="f_field.table == 'artwork_locations'"
          itemToAdd="f_field"
        ></add-location>
      </v-flex>
    </div>
  </div>
</template>

<script>
// import EditFieldHeader from '@/components/artists/EditFieldHeader'
import ViewArtworks from '@/components/artists/ViewArtworks'
// import dynamic_fields from '@/data/dynamic_fields'
import fields from '@/data/full_user_fields'
import AddArtist from '@/components/artists/AddArtist'
import AddLocation from '@/components/locations/AddLocation'
import Upload from '@/components/artworks/Upload'
import Location from '@/components/artworks/Location'
import Electrical from '@/components/artworks/Electrical'
import NonElectrical from '@/components/artworks/NonElectrical'
import Films from '@/components/artworks/Films'
import Audio from '@/components/artworks/Audio'
import Programme from '@/components/artworks/Programme'
import InformationCarrier from '@/components/artworks/InformationCarrier'
import Light from '@/components/artworks/Light'
import ReadingDevices from '@/components/artworks/ReadingDevices'
import Links from '@/components/artworks/Links'
import Costs from '@/components/artworks/Costs'
import LoanConditions from '@/components/artworks/LoanConditions'
// import EditField from './EditField'

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>'
  return (str + '').replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2'
  )
}

export default {
  name: 'edit-field',
  channels: [
    { id: 1, value: '1', name: 'Single-channel' },
    { id: 2, value: '2', name: 'Two-channel' },
    { id: 3, value: '3', name: 'Three-channel' },
    { id: 4, value: '4', name: 'Four-channel' },
    { id: 5, value: '5', name: 'Five-channel' },
    { id: 6, value: '6', name: 'Six-channel' },
    { id: 7, value: '7', name: 'Seven-channel' },
    { id: 8, value: '8', name: 'Eight-channel' },
    { id: 9, value: '9', name: 'Nine-channel' },
    { id: 10, value: '10', name: 'Ten-channel' },
    { id: 11, value: '11', name: '11-channel' },
    { id: 12, value: '12', name: '12-channel' },
    { id: 13, value: '13', name: '13-channel' },
    { id: 14, value: '14', name: '14-channel' },
    { id: 15, value: '15', name: '15-channel' },
  ],
  data() {
    return {
      // parent: [],
      toggle: 0,
      toggle_exclusive: 2,
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      select_value: '',
      show: true,
      model: {},
      menu2: '',
      date: '',
      // model: "artwork_location"
      // this.f_field.show
    }
  },
  props: [
    'field',
    'artwork',
    'placeholder',
    'label',
    'name',
    'value',
    'selection',
    'title',
    'film',
    'electrical',
    'report',
    'fields_parent',
    'parent',
    'light',
  ],
  mounted() {
    this.select_value = this.f_artwork[this.f_field.name]
    this.toggle = this.f_artwork[this.f_field.name]
  },
  methods: {
    showAddForm() {
      this.showingAddForm = !this.showingAddForm
    },
    add_field(field) {
      // console.log('sub')
      // console.log(document.getElementById(field.name))
      this.$emit('show', field)
      // var a = document.getElementById(field.name)
      // console.log(this.$el.style.display)
      // this.$el.style.display = 'block'
      // console.log(this.$children)
      // this.$children.find(a => a.name['name'] == field).styles.display = 'block'
      // console.log(this.$children.find(a => a.name['name'] == field).styles.display)
      // a.style.display = 'block'
      // a.style.backgroundColor = "green"
      // console.log(this.$el.style.display)
      // this.$forceUpdate()
    },
    save() {
      // this.toggle
    },
    saveOrEdit() {
      this.isEditing = !this.isEditing
      this.$refs[this.f_field['name']].isFocused = true
      // var a = document.getElementByName(this.f_field['name']).focus()
      // console.log(a)
      if (this.an_exists == false) {
        if (this.isEditing == false) {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      } else {
        this.cannotSave = true
        setTimeout(() => {
          this.cannotSave = false
        }, 4000)
      }
    },
    // nefunguje tak ako chcem
    // format_date (date,format) {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format(format)
    // },
    check_an(value) {
      // console.log(value)
      if (this.f_field.name == 'accession_number' && this.isEditing == true) {
        var a = Object.assign([], this.$store.state.artworks)
        var b = a.filter((aa) => aa.accession_number == value)
        this.an_exists = b.length > 0
        // console.log(this.an_exists)
        // console.log(value)
        // console.log(b)
        // console.log(a)
        // console.log(an)
      }
    },
    location_name(id) {
      if (id > 0) {
        return this.$store.state.locations.find((l) => l.id === id).name
      } else {
        return 'Location not found. Probably deleted from CMS.'
      }
    },
  },
  computed: {
    hint() {
      var out = this.f_field.title
      out = out + (this.f_field.hint ? ' - ' + this.f_field.hint : '')
      return out
    },
    value2() {
      // console.log(parseInt(this.f_artwork[this.f_field.related_field],10))
      return parseInt(this.f_artwork[this.f_field.related_field], 10)
    },
    value_radio() {
      // console.log(this.f_artwork[this.f_field.name])
      return this.f_artwork[this.f_field.name]
    },
    dynamic_field_list() {
      if (this.f_field.headline) {
        // console.log('test1')
        // console.log(dynamic_fields.dynamic_fields)
        // console.log(this.f_artwork.classification)
        // console.log(this.f_field.h)
        // console.log(dynamic_fields.dynamic_fields[this.f_artwork.classification])
        // var a = dynamic_fields['dynamic_fields'][this.f_artwork.classification]
        var c = []
        if (this.report) {
          var fields2 = this.fields_parent
        } else {
          var fields2 =
            fields['tabs'][this.$store.state.currentTab.substr(4)]['fields']
        }
        // console.log(fields2)
        // console.log('fields2')
        // var fields2 = Object.values(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification])
        // console.log('test')
        // if (fields2.length > 0) {
        // var class_fields = fields2[this.f_artwork.classification]
        c = fields2.filter(
          (f) => f.dynamic && f.section === this.f_field.section
        )
        c = c.filter(
          (f) =>
            f.work_types && f.work_types.includes(this.artwork.classification)
        )
        // console.log(c)
        // }
        // console.log(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification].filter(f => f.dynamic))
        return c
        // Object.values(a).filter(f => f.section === this.f_field.section)
        // console.log('test')
      } else {
        // console.log('not headline')
        return []
      }
      // return dynamic_fields[this.f_artwork.ownership][this.f_field.title]
    },
    // split_date () {
    // var moment = require('moment')
    // var date = this.f_artwork[this.f_field.name]
    // var ndate = moment(this.f_artwork[this.f_field.name],'YYYY')
    // var out = [ndate.year,ndate.month,ndate.day]
    // var out = [date.getFullYear,date.getMonth,date.getDay]
    // return ndate
    // },
    // field_value () {
    //   return this.f_artwork[this.f_field.name]
    // },
    // is_field_value () {
    //   // console.log(typeof this.field_value)
    //   // console.log(this.field_value)
    //   if (this.field_value == null) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype
    },
    selection_items() {
      if (this.f_field.table) {
        if (this.f_field.table == 'contacts') {
          var contacts = Object.assign([], this.$store.state.contacts)
          if (this.f_field.column) {
            // console.log(this.f_field.column)
            // console.log(this.f_field.association)
            // console.log(contacts.filter(c => c[this.f_field.column] == this.f_field.association))
            return contacts.filter(
              (c) => c[this.f_field.column] == this.f_field.association
            )
          } else {
            return contacts
          }
        }
        if (this.f_field.table == 'artists') {
          var artists = Object.assign([], this.$store.state.artists)
          if (this.f_field.column) {
            return artists.filter(
              (c) => c[this.f_field.column] == c[this.f_field.association]
            )
          } else {
            return artists.sort(dynamicSort('name'))
          }
        }
        if (this.f_field.table == 'artwork_locations') {
          // console.log(this.f_field.table)
          // console.log('this.f_field.table')
          var artwork_locations = Object.assign(
            [],
            this.$store.getters.enabled_locations
          )
          if (this.f_field.column) {
            return artwork_locations.filter(
              (c) => c[this.f_field.column] == c[this.f_field.association]
            )
          } else {
            return artwork_locations.sort(dynamicSort('name'))
          }
        }
      }
      if (this.f_field.selection && this.f_field.selection.length > 0) {
        return this.f_field.selection
      }
    },
    f_field() {
      var f = this.field
      f.model_string = this.field.model_string
        ? this.field.model_string
        : this.field.name
      f.column = this.field.column ? this.field.column : false
      // console.log(this.f_artwork[this.field.name])
      f.value_string = this.field['model_string']
        ? this[this.field.model_string]
        : this.f_artwork[this.field.name]
      return f
    },
    f_artwork() {
      return this.artwork
    },
    // value_calculated () {
    //   let output = ''
    //   switch (this.f_field.table) {
    //     case 'artworks':
    //       if (this.f_field.name)
    //         output = nl2br(this.f_artwork[this.field.name])
    //       else
    //         output = 'no artwork name entered in cms'
    //       break
    //     case 'artwork_locations':
    //       output = nl2br(this.f_artwork[this.f_field.association][this.f_field.name])
    //       break
    //     case 'contacts':
    //       output = nl2br(this.f_artwork[this.f_field.association][this.f_field.name])
    //       break
    //     default:
    //       output = nl2br(this.f_artwork[this.f_field.name])
    //     if (output === undefined) {
    //       output = ''
    //     }
    //     if (output === null) {
    //       output = 0
    //     }
    //     if (this.f_field.suffix) {
    //       output += this.f_field.suffix
    //     }
    //       // console.log(this.f_artwork)
    //   }
    //   return output
    // },
    // value_from_array () {
    //   let v = this.value_calculated
    //   return this.f_field.options[v]
    // },
    // value_calculated_empty () {
    //   let output = ''
    //   // let a = this.f_artwork.id
    //   // console.log(this.f_artwork)
    //   switch (this.f_field.table) {
    //     case 'artworks':
    //       if (typeof this.f_artwork !== 'undefined') {
    //         output = this.f_artwork[this.f_field.name]
    //       } else {
    //         output = ''
    //       }
    //       break
    //     case 'artwork_locations':
    //       if (typeof this.f_artwork[this.f_field.association] !== 'undefined') {
    //         output = this.f_artwork[this.f_field.association][this.f_field.name]
    //       } else {
    //         output = ''
    //       }
    //       break
    //     case 'contacts':
    //       if (typeof this.f_artwork[this.f_field.association] !== 'undefined') {
    //         output = (this.f_artwork[this.f_field.association][this.f_field.name])
    //       } else {
    //         output = ''
    //       }
    //       break
    //     default:
    //       output = this.f_artwork[this.f_field.name]
    //   }
    //   let o=false
    //   if (output=='' || output==undefined || output==null) {
    //     o = false
    //   } else {
    //     o = true
    //   }
    //   return o
    // }
  },
  components: {
    AddLocation,
    AddArtist,
    Costs,
    ViewArtworks,
    Upload,
    Location,
    Films,
    Audio,
    Light,
    Programme,
    InformationCarrier,
    Electrical,
    ReadingDevices,
    Links,
    NonElectrical,
    LoanConditions,
  },
}
</script>

<style scoped>
li {
  list-style: none;
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/EditFieldComp.vue